import { Button, Dialog, InteractiveContainer } from "@jugl-web/ui-kit";
import React from "react";
import { useTranslations } from "@jugl-web/utils";
import automationUpdatesImage from "./assets/automation-updates.png";
import { ReactComponent as CrossIcon } from "./assets/cross.svg";
import { ReactComponent as WhatsappIcon } from "./assets/whatsapp.svg";

export const AutomationUpdatesDialog: React.FC<{
  isOpen: boolean;
  onRequestClose: () => void;
}> = ({ isOpen, onRequestClose }) => {
  const { t } = useTranslations();

  return (
    <Dialog isOpen={isOpen} onClose={onRequestClose} className="flex flex-col">
      <div className="flex min-h-[60px] items-center justify-between border-x-0 border-t-0 border-b border-solid border-b-gray-100 px-6 py-[14px]">
        <div className="flex items-center gap-3">
          <WhatsappIcon />
          <span className="text-sm font-semibold text-[#383838]">
            {t({
              id: "client-support-page.templates-automation",
              defaultMessage: "Templates Automation",
            })}
          </span>
        </div>
        <InteractiveContainer
          className="ml-auto h-8 w-8"
          onClick={onRequestClose}
        >
          <CrossIcon />
        </InteractiveContainer>
      </div>
      <div className="flex flex-col items-center overflow-y-auto px-20 pt-8 pb-14 text-center">
        <img src={automationUpdatesImage} alt="" />
        <span className="mt-4 font-secondary text-[22px] leading-[150%] font-semibold text-dark">
          {t({
            id: "client-support-page.customize-templates-with-variables",
            defaultMessage: "Customize templates with Variables!",
          })}
        </span>
        <span className="mt-2 leading-[150%] text-dark-800">
          {t({
            id: "client-support-page.automation-templates-description",
            defaultMessage:
              "Add variables to personalize your WhatsApp templates for each Customer by automatically entering specific information such as Order Name, Customer Name, Order Status or other relevant information 😍",
          })}
        </span>
        <Button onClick={onRequestClose} className="mt-10 w-[200px]">
          {t({
            id: "common.start",
            defaultMessage: "Start",
          })}
        </Button>
      </div>
    </Dialog>
  );
};
